import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {Project} from './project'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {SearchProjects} from '@github-ui/server-persisted-queries'
import type {SearchProjectsQuery} from '@github-ui/server-persisted-queries/types/SearchProjects'

export type GetSearchProjectsRequest = {
  owner: string
  repo: string
  query?: string
  count?: number
}

export type GetSearchProjectsResponse = GraphQLResponse<SearchProjectsQuery>

export async function apiGetSearchProjects({
  owner,
  repo,
  query,
  count,
}: GetSearchProjectsRequest): Promise<GetSearchProjectsResponse> {
  const params: Record<string, unknown> = {owner, repo, queryId: SearchProjects}

  if (query) {
    params['query'] = query
  }

  if (count) {
    params['count'] = count
  }

  const requestUrl = buildItemPickerSearchUrl('projects', params)
  const request = await verifiedFetchJSON(requestUrl)
  return (await request.json()) as GetSearchProjectsResponse
}

const itemPickerQueryKeyBase = 'item_picker'

export function buildProjectPickerSearchQueryKey(searchParams: GetSearchProjectsRequest) {
  return [itemPickerQueryKeyBase, 'projects', searchParams]
}

export type ProjectPickerQueryData = {
  repositoryProjects: Project[]
  recentRepositoryProjects: Project[]
  ownerProjects: Project[]
  recentOwnerProjects: Project[]
}

export function transformSearchProjectResponseToQueryData(response: SearchProjectsQuery): ProjectPickerQueryData {
  if (!response.repository) {
    throw new Error('Repository not found in search projects response')
  }

  const {repository} = response

  return {
    repositoryProjects: (repository.projectsV2.nodes ?? []).flatMap(node => (node ? [node] : [])),
    recentRepositoryProjects: (repository.recentProjects.edges ?? []).flatMap(edge => (edge?.node ? [edge.node] : [])),
    ownerProjects: (repository.owner.projectsV2.edges ?? []).flatMap(edge => (edge?.node ? [edge.node] : [])),
    recentOwnerProjects: (repository.owner.recentProjects.edges ?? []).flatMap(edge => (edge?.node ? [edge.node] : [])),
  }
}
